var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex" } },
    [
      _c(
        "div",
        {
          staticClass: "phone",
          style: {
            backgroundImage:
              "url(" + _vm.api.temp.FILE_PATH + _vm.url.bgUrl + ")",
          },
          on: {
            click: function ($event) {
              _vm.visible = true
            },
          },
        },
        [
          _c("img", {
            staticClass: "img1",
            attrs: { src: _vm.api.temp.FILE_PATH + _vm.url.coverUrl, alt: "" },
          }),
          _c("img", {
            staticClass: "img2",
            attrs: { src: require("@/assets/img/active/game_fk.png"), alt: "" },
          }),
        ]
      ),
      _c(
        "div",
        { staticClass: "form" },
        [
          _vm.index === 0
            ? _c("Step1", {
                attrs: {
                  rowId: _vm.actId,
                  url: _vm.url,
                  templateId: _vm.templateId,
                },
                on: { cancel: _vm.cancel, nextStep: _vm.nextStep },
              })
            : _vm._e(),
          _vm.index === 1
            ? _c("Step2", {
                attrs: { rowId: _vm.actId, templateId: _vm.templateId },
                on: { lastStep: _vm.lastStep, nextStep: _vm.nextStep },
              })
            : _vm._e(),
          _vm.index === 2
            ? _c("Step3", {
                attrs: { rowId: _vm.actId, templateId: _vm.templateId },
                on: { lastStep: _vm.lastStep, nextStep: _vm.nextStep },
              })
            : _vm._e(),
          _vm.index === 3
            ? _c("Step4", {
                attrs: { rowId: _vm.actId, templateId: _vm.templateId },
                on: { lastStep: _vm.lastStep, saved: _vm.saved },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: { title: "编辑图片", width: 800, footer: null },
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c("div", [_vm._v("首页元素：")]),
          _c("div", { staticClass: "item" }, [
            _c("div", [_vm._v(" 背景图:")]),
            _c(
              "div",
              [
                _c(
                  "a-upload",
                  {
                    staticClass: "avatar-uploader upload",
                    attrs: {
                      action: _vm.api.temp.UPLOAD_PATH,
                      headers: _vm.headers,
                      accept: ".jpg,.gif,.png",
                      multiple: false,
                      showUploadList: false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "bgUrl")
                      },
                    },
                  },
                  [
                    !_vm.url.bgUrl
                      ? _c(
                          "div",
                          { staticClass: "ant-upload-text" },
                          [
                            _c("a-icon", { attrs: { type: "plus" } }),
                            _c("div", { staticClass: "ant-upload-text" }, [
                              _vm._v(" 上传图片 "),
                            ]),
                          ],
                          1
                        )
                      : _c("img", {
                          attrs: {
                            src: _vm.api.temp.FILE_PATH + _vm.url.bgUrl,
                            alt: "",
                          },
                        }),
                  ]
                ),
              ],
              1
            ),
            _c("div", [_vm._v("图片像素建议为750px*1500px 格式为jpg/png/gif")]),
          ]),
          _c("div", { staticClass: "item" }, [
            _c("div", [_vm._v(" 封面图:")]),
            _c(
              "div",
              [
                _c(
                  "a-upload",
                  {
                    staticClass: "avatar-uploader upload",
                    attrs: {
                      action: _vm.api.temp.UPLOAD_PATH,
                      headers: _vm.headers,
                      accept: ".jpg,.gif,.png",
                      multiple: false,
                      showUploadList: false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.handleChange($event, "coverUrl")
                      },
                    },
                  },
                  [
                    !_vm.url.coverUrl
                      ? _c(
                          "div",
                          { staticClass: "ant-upload-text" },
                          [
                            _c("a-icon", { attrs: { type: "plus" } }),
                            _c("div", { staticClass: "ant-upload-text" }, [
                              _vm._v(" 上传图片 "),
                            ]),
                          ],
                          1
                        )
                      : _c("img", {
                          attrs: {
                            src: _vm.api.temp.FILE_PATH + _vm.url.coverUrl,
                            alt: "",
                          },
                        }),
                  ]
                ),
              ],
              1
            ),
            _c("div", [_vm._v("图片像素建议为700px*260px 格式为jpg/png/gif")]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }